import script from "./ExpensesChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpensesChart.vue?vue&type=script&setup=true&lang=js"

import "./ExpensesChart.vue?vue&type=style&index=0&id=f6a8ec3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6a8ec3a"]])

export default __exports__